import { render, staticRenderFns } from "./KETable.vue?vue&type=template&id=1d5b8ca6&scoped=true&"
import script from "./KETable.vue?vue&type=script&lang=ts&"
export * from "./KETable.vue?vue&type=script&lang=ts&"
import style0 from "./KETable.vue?vue&type=style&index=0&id=1d5b8ca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b8ca6",
  null
  
)

export default component.exports